import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { verticalGutter, breakpoints } from '../../styles';

// TODO: must use gloal form field styles somehow
export default styled(Link)`
  max-width: 167px;
  display: inline-block;

  @media only screen and (min-width: ${breakpoints.tablet}) {
    max-width: 210px;
    margin-right: ${verticalGutter};
  }
  svg {
    display: block;
    max-width: 100%;
  }
`;
